import React, { useEffect, useState } from "react";
import { Formik, Field } from "formik";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Select,
  notification,
  DatePicker,
} from "antd";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  addSelectedRawMaterial,
  updateSelectedRawMaterial,
  toggleNewDialog,
  emptySelectedRawMaterial,
  addBomDetail,
  toggleNewEditDialog,
} from "../store/stateSlice";
import {
  getBom,
  getBomDetails,
  getOrderID,
  getrawMaterial,
  postBom,
  updateBom,
} from "../store/dataSlice";
import moment from "moment";
import RawMaterialTable from "./RawMaterialTable";

const { Option } = Select;

const RawMaterialForm = ({ type }) => {
  const [orderId, setOrderId] = useState("");
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const selectedEmployee = useSelector(
    (state) => state.rawMaterial.state.selectedraw
  );
  const orderID = useSelector(
    (state) => state.rawMaterial.data.orderIdList?.data
  );
  const rawMaterial = useSelector(
    (state) => state.rawMaterial.data.rawMaterialList?.data
  );
  const editRawMaterial = useSelector(
    (state) => state.rawMaterial.state.selectedEditRawMaterial
  );
  const data = useSelector(
    (state) => state.rawMaterial.state.selectedRawMaterial
  );
  const selectedBom = useSelector(
    (state) => state.rawMaterial.state.selectedbom
  );
  const BomData = useSelector((state) => state.rawMaterial.data.bomDetailList);

  useEffect(() => {
    dispatch(getOrderID());
    dispatch(getrawMaterial());
  }, [dispatch]);

  useEffect(() => {
    if (type === "edit") {
      dispatch(
        getBomDetails({
          bom_id: selectedBom?.bom_id,
        })
      );

      if (Object.keys(BomData).length > 0) {
        setOrderId(selectedBom?.order_id);
        dispatch(addBomDetail(BomData?.BOMDetails));
      }
    }
  }, [type, selectedBom, Object.keys(BomData).length > 0]);

  const validationSchema = Yup.object({
    order_id: Yup.string().required("Order No is required"),
    date: Yup.string().required("Date is required"),
    product: Yup.string().required("Raw Material is required"),
    quantity: Yup.string().required("Quantity is required"),
    description: Yup.string().required("Description is required"),
  });

  const handleSave = async (dataArray) => {
    let data = {
      items: dataArray.map((m) => {
        const { Product, quantity, date, description } = m;

        return {
          date,
          description,
          quantity: parseFloat(quantity),
          product_id: Product.product_id,
        };
      }),
    };

    if (type === "edit") {
      data.order_id = orderId;
      data.bom_id = selectedBom?.bom_id;
      const action = await dispatch(updateBom(data));
      if (action.payload.status < 300) {
        notification.success({ message: "Data Updated successfully!" });
        dispatch(emptySelectedRawMaterial([]));
        dispatch(toggleNewEditDialog(false));
        setOrderId("");
        dispatch(getBom());
      } else {
        notification.error({ message: action?.payload });
      }
    } else {
      data.order_id = orderId;
      const action = await dispatch(postBom(data));
      if (action.payload.status < 300) {
        notification.success({ message: "Bom Submitted successfully!" });
        dispatch(toggleNewDialog(false));
        dispatch(emptySelectedRawMaterial([]));
        setOrderId("");
        dispatch(getBom());
      } else {
        notification.error({ message: action?.payload });
      }
    }
  };

  const handleSubmit = async (
    values,
    { setSubmitting, resetForm, setFieldValue }
  ) => {
    if (editRawMaterial && Object.keys(editRawMaterial).length > 0) {
      await dispatch(updateSelectedRawMaterial(values));
    } else {
      await dispatch(addSelectedRawMaterial(values));
    }
    setFieldValue("Product", "");
    setFieldValue("quantity", "");
    setFieldValue("date", "");
    setFieldValue("description", "");
    setSubmitting(false);
  };

  return (
    <>
      <div className="mt-4">
        {contextHolder}
        <Formik
          enableReinitialize
          initialValues={{
            order_id: orderId,
            date: editRawMaterial?.date || "",
            Product: editRawMaterial?.Product || "",
            quantity: editRawMaterial?.quantity || "",
            description: editRawMaterial?.description || "",
          }}
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            touched,
            errors,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => {
            if (values.order_id) {
              setOrderId(values.order_id);
            }
            return (
              <Form
                onFinish={handleSubmit}
                onFinishFailed={(errorInfo) => {
                  console.error("Failed:", errorInfo);
                }}
              >
                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.order_id && errors.order_id
                          ? errors.order_id
                          : ""
                      }
                      validateStatus={
                        touched.order_id && errors.order_id
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Order No.</span>
                      <Select
                        showSearch
                        placeholder="Select Order No"
                        onChange={(value) => setFieldValue("order_id", value)}
                        value={values.order_id}
                        disabled={type === "edit"}
                        className="h-[40px] rounded"
                      >
                        {orderID?.map((type) => (
                          <Option
                            key={type.order_id}
                            value={type.order_id}
                            className="text-gray-400"
                          >
                            {type.order_number}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={6}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.product && errors.product ? errors.product : ""
                      }
                      validateStatus={
                        touched.product && errors.product ? "error" : undefined
                      }
                    >
                      <span className="text-xs">Raw Material</span>
                      <Select
                        showSearch
                        name="Product"
                        value={values.Product?.product_id}
                        placeholder="Select Raw Material"
                        onChange={(value) => {
                          const selectedProduct = rawMaterial.find(
                            (type) => type.Product?.product_id === value
                          );

                          handleChange({
                            target: {
                              name: "Product",
                              value: {
                                product_id:
                                  selectedProduct?.Product?.product_id,
                                part_name: selectedProduct?.Product?.part_name,
                                description:
                                  selectedProduct?.Product?.description,
                                v_code: selectedProduct?.v_code,
                                drawing_number:
                                  selectedProduct?.Product?.drawing_number,
                                material_grade_id:
                                  selectedProduct?.Product?.MaterialGrade
                                    ?.number,
                              },
                            },
                          });
                        }}
                        className="h-[40px] rounded"
                        // value={values.product.product_id || ""}
                      >
                        {rawMaterial?.map((type) => (
                          <Option
                            key={type.product_id}
                            value={type.Product?.product_id}
                            className="text-gray-400"
                          >
                            {`${type.v_code} : ${type.Product.description} : ${type.Product.MaterialGrade.number}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.quantity && errors.quantity
                          ? errors.quantity
                          : ""
                      }
                      validateStatus={
                        touched.quantity && errors.quantity
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Quantity</span>
                      <Input
                        name="quantity"
                        placeholder="Quantity"
                        value={values.quantity}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="!rounded"
                        style={{ padding: "8px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      className="flex flex-col"
                      help={touched.date && errors.date ? errors.date : ""}
                      validateStatus={
                        touched.date && errors.date ? "error" : undefined
                      }
                    >
                      <span className="text-xs">Date</span>
                      <Field name="date">
                        {({ field, form }) => (
                          <DatePicker
                            {...field}
                            value={field.value ? moment(field.value) : null}
                            onChange={(date, dateString) =>
                              form.setFieldValue("date", dateString)
                            }
                            onBlur={form.handleBlur}
                            className="!rounded"
                            style={{ width: "100%", padding: "8px" }}
                          />
                        )}
                      </Field>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      className="flex flex-col"
                      help={
                        touched.description && errors.description
                          ? errors.description
                          : ""
                      }
                      validateStatus={
                        touched.description && errors.description
                          ? "error"
                          : undefined
                      }
                    >
                      <span className="text-xs">Description</span>
                      <Input
                        name="description"
                        placeholder="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className="!rounded"
                        style={{ padding: "8px" }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Button
                      htmlType="submit"
                      disabled={isSubmitting}
                      type="primary"
                      className="mt-6"
                    >
                      Add
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
      <RawMaterialTable />
      <div className="flex justify-end m-4 gap-2">
        <Button type="primary" onClick={() => handleSave(data)}>
          Save & Close
        </Button>
      </div>
    </>
  );
};

export default RawMaterialForm;
